import { ScheduleStatusReportItem } from '@mi-front/core';
import { Chip, ChipProps, MrtTable } from '@mi-front/ui';
import { Info as InfoIcon } from '@mui/icons-material';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { RowAction } from '../../../../../../components/table/RowAction';
import { RowActions } from '../../../../../../components/table/RowActions';
import { ReportResultProps } from '../../../../../../core/reports/types';
import { useActiveStation } from '../../../../../../core/stations/hooks/useActiveStation';
import { AuditMediaPlayerAction } from '../../../../components/AuditMediaPlayerAction';
import { useAuditSpotMatches } from '../../../../hooks/useAuditSpotMatches';
import { ScheduleStatusDetailDialog } from './ScheduleStatusDetailDialog';
import { ScheduleStatusAdsReport } from './ScheduleStatusAdsView';

export function ScheduleStatusAdsResult(p: ReportResultProps<ScheduleStatusAdsReport>) {
  const { $t } = useIntl();
  const station = useActiveStation();
  const [detail, showDetail] = useState<ScheduleStatusReportItem | null>(null);

  const matchesQuery = useAuditSpotMatches(
    station,
    {
      from: p.values.from,
      to: p.values.to,
    },
    {
      customId: detail?.customId ?? null,
    },
  );

  return (
    <>
      <MrtTable
        data={p.result.items}
        columns={[
          {
            header: $t({
              id: 'audit.props.customAudioId',
              defaultMessage: 'Archivo ID',
            }),
            accessorKey: 'customId',
            size: 150,
          },
          {
            header: $t({
              id: 'audit.scheduleStatusScreen.status',
              defaultMessage: 'Status: matches / matches c. schedule / schedules',
            }),
            size: 350,
            id: 'status',
            Cell: ({ row: { original: item } }) => {
              const {
                matchesCount,
                matchesWithScheduleCount,
                matchesWithScheduleOffToleranceCount,
                schedulesCount,
              } = item.status;

              let chipType: ChipProps['type'];

              if (matchesCount === 0) {
                chipType = 'light';
              } else if (
                matchesWithScheduleCount - matchesWithScheduleOffToleranceCount >=
                schedulesCount
              ) {
                chipType = 'success';
              } else {
                chipType = 'yellow';
              }

              return (
                <Chip type={chipType}>
                  {matchesCount} / {matchesWithScheduleCount} / {schedulesCount}{' '}
                  {!item.audio && (
                    <>
                      -{' '}
                      <FormattedMessage
                        id="audit.scheduleStatusScreen.noAudio"
                        defaultMessage="Sin material"
                      />
                    </>
                  )}
                </Chip>
              );
            },
          },
          {
            header: $t({
              id: 'common.text.actions',
              defaultMessage: 'Acciones',
            }),
            id: 'actions',
            size: 150,
            Cell: ({ row }) => (
              <RowActions>
                <RowAction
                  title={
                    <FormattedMessage
                      id="audit.schedulesListScreen.viewScheduleBtn"
                      defaultMessage="Ver detalle"
                    />
                  }
                  onClick={() => showDetail(row.original)}
                  icon={<InfoIcon />}
                />

                {row.original.audio && (
                  <AuditMediaPlayerAction
                    audio={{
                      ...row.original.audio,
                      stationId: station.id,
                    }}
                  />
                )}
              </RowActions>
            ),
          },
        ]}
      />
      <ScheduleStatusDetailDialog
        item={detail}
        onHide={() => showDetail(null)}
        matchesQuery={matchesQuery}
      />
    </>
  );
}
